import { ASSET_TYPE_KEYS } from 'modules/estatePlan/constants';

export const ASSET_TYPES_DOC_GEN = {
  PATIENT_DECREE: ASSET_TYPE_KEYS.PATIENT_DECREE,
  HEALTH_CARE_PROXY: ASSET_TYPE_KEYS.HEALTH_CARE_PROXY,
  ORGAN_DONOR_CARD: ASSET_TYPE_KEYS.ORGAN_DONOR_CARD,
  WILL: ASSET_TYPE_KEYS.WILL,
  PET_WATCHING_AGREEMENT: ASSET_TYPE_KEYS.PET_WATCHING_AGREEMENT,
};
